import React, { useState } from "react";
import { X, Search } from "lucide-react";

export default function StartDMModal({ isOpen, onClose, users, currentUserEmail, onSelectUser }) {
  if (!isOpen) return null;

  const [searchQuery, setSearchQuery] = useState("");

  const capitalizeName = (name) => {
    if (!name) return "";
    return name.split(" ").map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(" ");
  };

  const getFormattedName = (u) => {
    if (!u) return "";
    return capitalizeName(u.displayName || u.name || u.email?.split("@")[0] || "User");
  };

  // Filter out current user and deleted/disabled users
  const otherUsers = users.filter(
    u => u.email?.toLowerCase() !== currentUserEmail?.toLowerCase() && !u.deleted && u.status !== "Disabled"
  );

  const filteredUsers = otherUsers.filter(u => {
    const fullName = getFormattedName(u).toLowerCase();
    const email = (u.email || "").toLowerCase();
    const query = searchQuery.toLowerCase();
    return fullName.includes(query) || email.includes(query);
  });

  return (
    <div style={{
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.75)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 1100,
      backdropFilter: "blur(4px)"
    }}>
      <div 
        className="card glass-card animate-scale-up" 
        style={{
          width: "420px",
          maxWidth: "90%",
          height: "60vh",
          maxHeight: "550px",
          display: "flex",
          flexDirection: "column",
          padding: 0,
          border: "1px solid var(--border-color)",
          backgroundColor: "rgba(20, 24, 33, 0.95)",
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.5)"
        }}
      >
        {/* Modal Header */}
        <div style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "1rem 1.5rem",
          borderBottom: "1px solid var(--border-color)",
          backgroundColor: "rgba(10, 12, 18, 0.4)"
        }}>
          <h3 style={{ margin: 0, color: "var(--primary)", fontSize: "1.1rem", fontWeight: "700" }}>
            Direct Message
          </h3>
          <button 
            onClick={onClose}
            style={{
              background: "none",
              border: "none",
              color: "var(--text-secondary)",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <X size={18} />
          </button>
        </div>

        {/* Search Input */}
        <div style={{ padding: "1rem", borderBottom: "1px solid rgba(255, 255, 255, 0.05)" }}>
          <div style={{ position: "relative" }}>
            <span style={{ 
              position: "absolute", 
              left: "1rem", 
              top: "50%", 
              transform: "translateY(-50%)", 
              color: "rgba(255, 255, 255, 0.4)", 
              display: "flex" 
            }}>
              <Search size={16} />
            </span>
            <input 
              type="text" 
              placeholder="Search by name or email..." 
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              style={{
                width: "100%",
                padding: "0.55rem 1rem 0.55rem 2.25rem",
                fontSize: "0.8rem",
                borderRadius: "4px",
                border: "1px solid var(--border-color)",
                backgroundColor: "var(--bg-input)",
                color: "var(--text-primary)",
                outline: "none"
              }}
              autoFocus
            />
          </div>
        </div>

        {/* Users List */}
        <div style={{ flex: 1, overflowY: "auto", padding: "0.5rem" }}>
          {filteredUsers.length > 0 ? (
            filteredUsers.map((u) => {
              const fullName = getFormattedName(u);
              return (
                <div
                  key={u.id || u.email}
                  onClick={() => {
                    onSelectUser(u);
                    onClose();
                  }}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "0.75rem",
                    padding: "0.55rem 0.75rem",
                    borderRadius: "4px",
                    cursor: "pointer",
                    transition: "background 0.15s ease",
                    marginBottom: "0.25rem"
                  }}
                  className="slack-item-hover"
                >
                  <div style={{
                    width: "32px",
                    height: "32px",
                    borderRadius: "4px",
                    backgroundColor: u.role === "Admin" ? "#e74c3c" : (u.role === "Manager" ? "#3498db" : "#5a6275"),
                    color: "#ffffff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "700",
                    fontSize: "0.85rem",
                    flexShrink: 0
                  }}>
                    {fullName.substring(0, 1).toUpperCase()}
                  </div>
                  <div style={{ display: "flex", flexDirection: "column", minWidth: 0 }}>
                    <span style={{ fontSize: "0.82rem", color: "var(--text-primary)", fontWeight: "600", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                      {fullName}
                    </span>
                    <span style={{ fontSize: "0.7rem", color: "var(--text-secondary)", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                      {u.email}
                    </span>
                  </div>
                </div>
              );
            })
          ) : (
            <div style={{ padding: "2rem", textAlign: "center", color: "var(--text-secondary)", fontSize: "0.8rem" }}>
              No members found.
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
